import Http from '@/services/http';
import {
  AssetListPagedRequest,
  AssetListPagedResponse,
  AssetTreeviewItem,
} from 'sigma-mappings';

const urls = {
  getAssetsList: '/ativo/listagem',
  getAssetsTreeviewList: '/ativo/hierarquia',
};

export default {
  getAssetsList(payload) {
    const http = new Http();
    const mappedPayload = new AssetListPagedRequest(payload);
    return http.post(urls.getAssetsList, mappedPayload)
      .then(({ data }) => new AssetListPagedResponse(data));
  },
  getAssetsTreeviewList(installation) {
    const http = new Http();
    const queryString = {
      installation,
    };
    return http.get(urls.getAssetsTreeviewList, { queryString })
      .then(({ data }) => data.map(item => new AssetTreeviewItem(item)));
  },
};
